import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass($setup.cn('animate-pulse rounded-md bg-gray-200', $setup.props.class))
    }, null, 2 /* CLASS */));
}
